import { type FunctionComponent, } from "react";



export const UserStar: FunctionComponent<{}> = () => (
	<svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 3C9.80271 3 8 4.80271 8 7C8 9.19729 9.80271 11 12 11C14.1973 11 16 9.19729 16 7C16 4.80271 14.1973 3 12 3ZM12 5C13.1164 5 14 5.88359 14 7C14 8.11641 13.1164 9 12 9C10.8836 9 10 8.11641 10 7C10 5.88359 10.8836 5 12 5ZM12 14C8.859 14 3 15.545 3 18.5V21H14.1855L12.9688 19.9473L11.873 19H5V18.5C5 17.631 8.708 16 12 16C13.406 16 14.887 16.299 16.123 16.707L16.9023 14.8555C15.2223 14.2895 13.357 14 12 14ZM19.0117 15L17.6836 18.1426L14.2773 18.4336L16.8594 20.6699L16.084 23.998L19.0117 22.2344L21.9395 24L21.1641 20.6621L23.7461 18.4277L20.3418 18.1367L19.0117 15Z" />
	</svg>
);



